function init() {

  /////////////////////////////    ESG pages    ////////////////////////////////////


  if (window.matchMedia('screen and (min-width: 1000px)').matches) {

    let sectionBlockAnimate = document.querySelectorAll('.section-block-animate');
    let sectionBlockAnimateTrigger = document.querySelectorAll('#animate-trigger');
    if (sectionBlockAnimate) {
      gsap.from(sectionBlockAnimate, {
        autoAlpha: 0,
        duration: 1,
        x: '3500',
        stagger: 0.1,
        ease: 'none',
        scrollTrigger: {
          trigger: sectionBlockAnimateTrigger,
          start: 'top bottom+=25%',
          end: 'bottom center+=25%',
          scrub: 3
        }
      })
    }

    let bulletsFirst = document.querySelectorAll('ul.first-bullets li');
    let bulletsFirstTrigger = document.querySelectorAll('.first-bullets-animation');
    if (bulletsFirst && bulletsFirstTrigger) {
      gsap.from(bulletsFirst, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsFirstTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
    let bulletsSecond = document.querySelectorAll('ul.second-bullets li');
    let bulletsSecondTrigger = document.querySelectorAll('.second-bullets-animation');
    if (bulletsSecond && bulletsSecondTrigger) {
      gsap.from(bulletsSecond, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsSecondTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
    let bulletsThird = document.querySelectorAll('ul.third-bullets li');
    let bulletsThirdTrigger = document.querySelectorAll('.third-bullets-animation');
    if (bulletsThird && bulletsThirdTrigger) {
      gsap.from(bulletsThird, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsThirdTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
    let bulletsFourth = document.querySelectorAll('ul.fourth-bullets li');
    let bulletsFourthTrigger = document.querySelectorAll('.fourth-bullets-animation');
    if (bulletsFourth && bulletsFourthTrigger) {
      gsap.from(bulletsFourth, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsFourthTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
  }


  let contentAnimated = document.querySelectorAll('.content-animated');
  let contentAnimatedTrigger = document.querySelectorAll('#animate-content');
  if (contentAnimated && contentAnimatedTrigger) {
    gsap.from(contentAnimated, {
      opacity: 0,
      y: -100,
      ease: 'none',
      duration: 3,
      autoAlpha: 0,
      scrollTrigger: {
        trigger: contentAnimatedTrigger,
        start: 'top center+=50%',
        scrub: true
      }
    })
  }

  let tencelIcons = document.querySelectorAll('#tencel-icons .image-wrapper');
  let tencelIconsTrigger = document.querySelectorAll('#tencel-icons');
  if (tencelIcons && tencelIconsTrigger) {
    if (window.matchMedia('screen and (min-width: 1000px)').matches) {
      gsap.from(tencelIcons, {
        opacity: 0,
        x: -500,
        ease: 'back.inOut',
        stagger: 0.1,
        duration: 1,
        autoAlpha: 0,
        scrollTrigger: {
          trigger: tencelIconsTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      }, 0.2)

      if (window.matchMedia('screen and (max-width: 999px)').matches) {
        gsap.from(tencelIcons, {
          opacity: 0,
          x: -100,
          ease: 'back.inOut',
          stagger: 0.2,
          autoAlpha: 0,
          duration: 5,
          scrollTrigger: {
            trigger: tencelIconsTrigger,
            start: 'top center+=30%',
            end: 'bottom center+=30%',
            scrub: true
          }
        })
      }
    }
  }

  let esgChain = document.querySelectorAll('#esg-chain .image-wrapper');
  let esgChainTrigger = document.querySelectorAll('#esg-chain');
  if (esgChain && esgChainTrigger) {
    if (window.matchMedia('screen and (max-width: 1099px)').matches) {
      gsap.from(esgChain, {
        opacity: 0,
        x: -100,
        ease: 'back.inOut',
        stagger: 0.2,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: esgChainTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      })
    }

    if (window.matchMedia('screen and (min-width: 1100px)').matches) {
      gsap.from(esgChain, {
        opacity: 0,
        x: -500,
        ease: 'back.inOut',
        stagger: 0.1,
        duration: 1,
        autoAlpha: 0,
        scrollTrigger: {
          trigger: esgChainTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      }, 0.2)
    }
  }

  if (window.matchMedia('screen and (min-width: 699px)').matches) {
    let tencelProcess = document.querySelectorAll('#tencel-process .image-wrapper');
    let tencelProcessTrigger = document.querySelectorAll('#tencel-process');
    if (tencelProcess && tencelProcessTrigger) {
      gsap.from(tencelProcess, {
        opacity: 0,
        y: -500,
        ease: 'back.inOut',
        stagger: 0.2,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: tencelProcessTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      })
    }
  }
}


/**
 * Run all animation functions after DOM has fully 
 * loaded in order to prioritize content visibility
 */
document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);
  init();
});